<template>
  <div>
    <b-modal
      id="modal-bulk-action"
      ref="modal"
      v-model="open"
      hide-footer
      no-close-on-backdrop
      size="lg"
      title="BULK ACTION"
      class="p-4"
    >
      <template #modal-header>
        <h5
          class="modal-title"
        >
          BULK ACTION
        </h5>
        <button
          v-if="!loadingResponse"
          type="button"
          class="close"
          :disabled="loadingResponse"
          @click="handleCloseButtonClick"
        >
          <span>&times;</span>
        </button>
      </template>
      <h5 class="mb-2 ml-1">
        Waybill Numbers
      </h5>
      <b-badge
        v-for="(waybill, index) in waybillArray"
        :key="index"
        variant="light-primary"
        class="mr-1 mb-1 ml-1"
      >
        {{ waybill }}
      </b-badge>
      <b-row class="mt-2">
        <b-col>
          <form-builder
            ref="formbuilderBulkAction"
            v-model="formData"
            :on-submit="onSubmit"
            grid-class="px-1 row"
            :form-structure="formStructure"
          >
            <template slot="buttons">
              <b-row>
                <b-col>
                  <b-button
                    type="submit"
                    class="vh-5 mt-2 ml-1 custom-button-color"
                    :disabled="loadingResponse"
                  >
                    {{ loadingResponse ? 'Submitting...' : 'Submit' }}
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </form-builder>
        </b-col>
      </b-row>
      <b-row
        v-if="errors.length > 0"
        class="mt-4"
      >
        <b-col>
          <b-table
            striped
            hover
            responsive
            :items="errors"
            :fields="fields"
          >
            <template #cell(status)="data">
              <b-badge variant="light-danger">
                {{ data ? 'error' : 'success' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BBadge,
  VBModal,
  BCol,
  BRow,
  BButton,
  BTable,
} from 'bootstrap-vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Ripple from 'vue-ripple-directive'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FormBuilder from '@/libs/builders/form-builder/FormBuilder.vue'

const orderRepository = RepositoryFactory.get('order')

function initialState() {
  return {
    open: false,
    formData: {},
    errors: [],
    loadingResponse: false,
    fields: [
      {
        key: 'waybill_number',
        label: 'Waybill Number',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'status',
        label: 'Status',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'error',
        label: 'Error',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
    ],
  }
}

export default {
  name: 'KeyFourModal',
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BModal,
    BBadge,
    BCol,
    BRow,
    BButton,
    FormBuilder,
    BTable,
  },
  mixins: [SuccessMessage, ErrorMessage],
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    form_structure: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    status_key: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    selected_waybill_array: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
  },
  data() {
    return initialState()
  },
  computed: {
    formStructure() {
      return this.form_structure.filter(n => n.value !== 'waybill_number').map(m => {
        const obj = m
        // obj.class = 'col-12'
        return obj
      })
    },
    statusKey() {
      return this.status_key
    },
    waybillArray() {
      return this.selected_waybill_array
    },
  },
  methods: {
    // eslint-disable-next-line camelcase
    async openModal() {
      await Object.assign(this.$data, initialState())
      this.loadingResponse = false
      this.open = true
    },
    async handleCloseButtonClick() {
      this.open = false
    },
    async onSubmit() {
      try {
        this.loadingResponse = true
        const payload = {}
        payload.other_details = this.formData
        payload.waybill_numbers = this.waybillArray
        payload.status_key = this.statusKey
        await orderRepository.updateOrderStatus(payload)
        this.loadingResponse = false
        this.showSuccessMessage('Order updated successfully')
        if (this.$parent.getOrderSummary) {
          this.$parent.getOrderSummary()
          this.$parent.fetchOrdersList()
        }
        this.open = false
        this.$parent.selectedWaybillArray = []
        if (this.status_key === 'key_21') {
          this.$parent.fetchOrderList()
        } else {
          this.$parent.getOrderList()
        }
      } catch (e) {
        this.loadingResponse = false
        this.errors = []
        const errors = e.response.data.message
        if (typeof errors === 'string') {
          this.errors.push({ waybill_number: '---', error: errors })
        } else {
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const error in errors) {
            const element = errors[error]
            this.errors.push({ waybill_number: element.waybill_number, error: element.error })
          }
          this.showErrorMessage('Something went wrong!')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../@core/scss/button-color.scss';
</style>
